// removed by extract-text-webpack-plugin
module.exports = {"tooltip-size-control":"InlineTooltip__tooltip-size-control","tooltipSizeControl":"InlineTooltip__tooltip-size-control"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/InlineTooltip/InlineTooltip.tablet.css
// module id = 1129
// module chunks = 8